import React from "react";
import {getMsUrl} from "./web_config.jsx";


class TransportService {
    constructor() {
      
      this.ORIGIN = process.env.REACT_APP_ORIGIN;
      this.BASE_URL = getMsUrl("tr");
      this.GET_ALL_STOPS="/transport_service/api/v1/routePlaning/getStops";
      this.GET_ALL_CURRENCIES="transport_service/api/v1/currencies/getCurrencys";
      this.GET_OPERATOR_ROUTES="transport_service/api/v1/integrations/getRoutesByOrganization/";
      this.GETALLTICKETSBYOPERATORANDDATESINTERVAL=this.BASE_URL+"/api/v1/ticketing/getAllTicketsByOperatorAndDatesInterval";

      this.GET_DAILY_SCHEDULE=this.BASE_URL+"/api/v1/scheduling/getOperatorSchedulesByDateInterval";

      this.REMOVE_ROUTE_USER=this.BASE_URL+"/api/v1/branching/changeUserRouteOutletAssignmentStatus";

      this.FIND_USER_ROUTE_OUTLET_BY_USER=this.BASE_URL+"/api/v1/branching/findUserRouteOutletByUser/";

      this.GET_TRANS_USER_BY_ADMIN_ID = this.BASE_URL + "/api/v1/integrations/getUserByAdminId/";

      
    
    }
    setHeaders = (token) => {
      return {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer "+token,
          'Accept': 'application/json',
          'timeout': 900000
        },
      };
    };


    setHeadersFile = (token) => {
      return {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer "+token,
        },
      };
    };
  
}
 


class AdminService {
  constructor() {

    var data = {};
    const data1 = localStorage.getItem("nx_cent");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    this.accountData = data;

    this.ORIGIN = process.env.REACT_APP_ORIGIN;
    this.BASE_URL = getMsUrl("ad");
    this.CHANGE_PASSWORD=this.BASE_URL+"/api/v1/user/changePassword";
    this.RESET_AGENT_PIN=this.BASE_URL+"/api/v1/user/pos/resetPin/"
  }

  setHeaders = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": "Bearer "+token,
        "DeviceType":"OTHER",
        'Accept': 'application/json',
        'timeout': 900000
      },
    };
  };

  getBankCodes= () => {
    return [
      {
         "code": "00000","name":"BNR KIGALI"
      },
      {
          "code": "00010","name":"I AND M BANK"
      },
      {
          "code": "00020","name":"AB BANK"
      },
      {
          "code": "00025","name":"Commercial Bank of Africa Rwanda Plc"
      },
      {
          "code": "00040","name":"BK KIGALI"
      },
      {
          "code": "00070","name":"FINABANK KIGALI"
      },
      {
          "code": "00090","name":"UMWALIMU SACCO"
      },
      {
          "code": "00100","name":"ECOBANK KIGALI"
      },
      {
          "code": "00115","name":"ACCESS BANK KIGALI"
      },
      {
          "code": "00130","name":"CGBK CENTRALE"
      },
      {
          "code": "00145","name":"UOB KIGALI"
      },
      {
          "code": "00160","name":"KCB KIGALI"
      },
      {
          "code": "00175","name":"ZIGAMA CREDIT SAVING SCHEME"
      },
      {
          "code": "00192","name":"EQUITY BANK"
      },
      {
          "code": "00208","name":"BANK OF AFRICA RWANDA"
      },
      {
          "code": "00224","name":"UNGUKA"
      },
      {
          "code": "00400","name":"BPR KIGALI"
      }
  ];
  };
  

}


class FinanceService {
  constructor() {
    this.ORIGIN = process.env.REACT_APP_ORIGIN;
    this.BASE_URL = getMsUrl("fin");
    this.GET_AGENT_PROFILE=this.BASE_URL+"/api/v1/getAgentProfile/";
    this.GET_ACCOUNTS=this.BASE_URL+"/api/v1/getWalletByPhoneNumber/";
    this.TOPUP_CUSTOMER=this.BASE_URL+"/api/v1/customerWalletTopup";
    this.GET_TRANSACTIONS=this.BASE_URL+"/api/v1/getAgentTransactions/";
    this.GET_DEVICES=this.BASE_URL+"/api/v1/getAgentDevices/";
    this.GET_OUTLETS=this.BASE_URL+"/api/v1/getAgentOutlets/";
    this.FLOAT_ALLOCATION = this.BASE_URL+"/api/v1/agentFloatAllocation"

    this.GET_TOTAL_BY_TRANSACTION_TYPE = this.BASE_URL + "/api/v1/getTotalByTransactionType"

    this.GET_BRANCH_MANAGER_REPORT = this.BASE_URL + "/api/v1/getBranchReport"
    this.GET_BRANCH_MANAGER_REPORT = this.BASE_URL + "/api/v1/getBranchReport"

    // RNDPS 

    this.VALIDATE_FSP_ACCOUNT = this.BASE_URL + "/api/v1/rndps/accountLookup"
    this.RNDPS_CREDIT_TRANSFER = this.BASE_URL + "/api/v1/integration/rndpsCreditRequest"


    // AC GROUP TICKETS

    this.GET_AC_GROUP_TICKETS = this.BASE_URL + "/api/v1/getAcGroupTicketSummary";
    this.GET_AC_GROUP_TICKETS_REPORT = this.BASE_URL + "/api/v1/getAcGroupTickets";


    // SETTLEMENT REPORT 
    this.GET_SETTLEMENT_PROCESS=this.BASE_URL+"/api/v1/getSettlementProcesses";

    this.INITIATE_SETTLEMENT=this.BASE_URL+"/api/v1/getSettlementProcesses";

    this.GET_TRANSACTION_REQUEST = this.BASE_URL +"/api/v1/getTransactionRequests";

    // BALANCE 

    this.BALANCE=this.BASE_URL+"/api/v1/checkCardBalance/";


    // CARD PROFILE

    this.GET_CARD_PROFILE=this.BASE_URL+"/api/v1/getCardProfile/";

    // VALIDATE PAYMENT OTP

    this.VALIDATE_OPT_PAYMENT = this.BASE_URL + "/api/v1/integration/validatePaymentOtp";

    // VALIDATE FSP ACCOUNT

    this.VALIDATE_FSP_ACCOUNT = this.BASE_URL + "/api/v1/rndps/accountLookup";

    // TOP UP CARD
    this.TOP_UP_CARD=this.BASE_URL+"/api/v1/requestPaymentUrubutoPay";
    // this.TOP_UP_CARD = this.BASE_URL +"/api/v1/requestPayment";
    this.CHECK_PAYMENT_STATUS=this.BASE_URL+"/api/v1/checkPaymentStatus/";

    this.TOP_UP_TOKEN="Basic CARD_TOP_UP::eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDQVJEX1RPUF9VUCIsImV4cCI6MTY1MzM4NjgwOCwiaWF0IjoxNjIxODUwODA4fQ.4fe76sO_jMGshR2fHSyneFltAreqe7zQs5BL1IPN0wRxY6bOWCnhwyc30nNZ9M0B1yJ2JTGT3ni2akuciVwC2w";

    this.TOP_UP_TOKEN_TEST = "Basic topup::eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0b3B1cCIsImV4cCI6MTcwODA5ODQwNSwiaWF0IjoxNjc2NTYyNDA1fQ.W9_dbPfZr9GlJFCCmY0c-pDbRJU3UFPyDrSQaSMFl3fvPFyaJQG-c4-s1wABeW0eCwfoF8KFMM4WXZ0zLiG1Xg";

    
    this.OTP_VERIFICATION = "Basic OTP_VERIFICATION::eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJPVFBfVkVSSUZJQ0FUSU9OIiwiZXhwIjoxNzI1NzgxNzUzLCJpYXQiOjE2OTQyNDU3NTN9.PQIWHrUQRox4qHzarI4l8NUGHcgGdLkuXt1e8PLTA6HLUP3YnuFxNebCLxdmUrZk1xnDO-MgfgbDZu8X00dP-w";

    // this.TOP_UP_TEST_TOKEN="Basic topup::eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0b3B1cCIsImV4cCI6MTY1NDU4NjI0MywiaWF0IjoxNjIzMDUwMjQzfQ.n76DIwMOzQMUz2deFqpIkpqBFnU2lEA-SLrNTYSiAQf31dRbE_NmoDwVHe6XLJOIfSNvnZoXnc-R-NCRlAEN1g";

  }
  
  setHeaders = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        "Authorization": "Bearer "+token,
        'Accept': 'application/json',
      },
    };
  };

  setHeadersMicroservice = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        "Authorization": token,
        'timeout': 900000
      },
    };
  };

}




class ReportingService {
  constructor() {
    this.ORIGIN = process.env.REACT_APP_ORIGIN;
    this.BASE_URL = getMsUrl("re");
    this.ROUTE_PEFORMANCE_PASSENGER=this.BASE_URL+"/pos-report/route-daily-ticket";
    this.GET_NID_INFO=this.BASE_URL+"/nida/document";
    this.GET_AUDIT_TRAILS=this.BASE_URL+"/audit-trails/logs-filter";

    this.GET_REVENUE_PER_ORGANIZATION = this.BASE_URL + "/api/v1/inter-operability-reports/per-organisation"
    this.GET_REVENUE_PER_ROUTE = this.BASE_URL + "/api/v1/inter-operability-reports/per-route"
    this.GET_REVENUE_PER_PLATE_NUMBER = this.BASE_URL + "/api/v1/inter-operability-reports/per-plate-number"
    // this.GET_REVENUE_TICKETS = this.BASE_URL + "/api/v1/inter-operability-reports/get-detailed-ac-group-tickets"
    this.GET_REVENUE_TICKETS = this.BASE_URL + "/api/v1/inter-operability-reports/get-detailed-ac-group-tickets/paginated"
    this.GET_WEEK_INTER_REPORT = this.BASE_URL + "/api/v1/inter-operability-reports/weeklty-report"
    this.GET_MONTH_INTER_REPORT = this.BASE_URL + "/api/v1/inter-operability-reports/yearly-report"
    this.GET_INETEROPERABILITY_META_REPORT = this.BASE_URL + "/api/v1/inter-operability-reports/get-detailed-ac-group-tickets/meta"
    this.CHANNEL_REVENUE = this.BASE_URL + "/api/v1/inter-operability-reports/per-channel" 
    this.DOWNLOAD_REVENUE_TICKETS = this.BASE_URL + "/api/v1/inter-operability-reports/get-detailed-ac-group-tickets/download"
  }
  setHeaders = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        "Authorization": "Bearer "+token,
        'Accept': 'application/json',
        'timeout': 900000
      },
    };
  };


  setHeadersFile = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        "Authorization": "Bearer "+token,
        'Accept': 'application/json',
        'timeout': 900000
      },
      responseType: 'blob'
    };
  };


  


}


class Wizanlytics{

  constructor() {
    this.ORIGIN = process.env.REACT_APP_ORIGIN;
    this.BASE_URL = process.env.REACT_APP_WIZ_BASE_URL;
    this.AUTHENTICATE=this.BASE_URL+"/oauth/token";
    this.GET_BUSINESS_RULES=this.BASE_URL+"/api/v1/reward-rules";
    this.DELETE_BUSINESS_RULE=this.BASE_URL+"/api/v1/reward-rules/";
    this.NEW_BUSINESS_RULE=this.BASE_URL+"/api/v1/reward-rules";
    this.GET_USER_BALANCE=this.BASE_URL+"/api/v1/analytics/users";
  }


  setHeaders = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        "Authorization": "Bearer "+token,
        'Accept': 'application/json',
        'timeout': 900000
      },
    };
  };

  setHeadersAuth = () => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'Accept': 'application/json',
        'timeout': 900000
      },
    };
  };


}



function Permissions(props) {

  var match=false;
  var priveleges=[];

  const { permissions } = props

  if(permissions=="INITIAL"){
     match=true;
  }else{
    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
      priveleges=data['permissions'];   
      if(priveleges!=undefined){
        if(priveleges.find(o=>o.name==permissions)){
          match=true 
        }
      }
     
    }
  }

 

  return (
    <>
      {match ? props.children : <></>}
    </>

  )
}
 

/// grouping reports

function arrayFromObject(obj) {
  var arr = [];
  for (var i in obj) {
      arr.push(obj[i]);
  }
  return arr;
}

function groupBy(list, fn) {
  var groups = {};
  for (var i = 0; i < list.length; i++) {
      var group = JSON.stringify(fn(list[i]));
      if (group in groups) {
          groups[group].push(list[i]);
      } else {
          groups[group] = [list[i]];
      }
  }
  return arrayFromObject(groups);
}

// format money 

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};


function generateReference(max) {
  return Math.floor(Math.random() * max) + 1;
}
  
  export {TransportService,AdminService,FinanceService,ReportingService,Wizanlytics,Permissions,groupBy,generateReference,formatMoney};
  